export default __webpack_public_path__ + "static/media/newLogoBox.087dce14.svg";